{
  "title": "Revivify",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level necromancy",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (diamonds worth 300 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You touch a creature that has died within the last minute. That creature returns to life with 1 hit point. This spell can’t return to life a creature that has died of old age, nor can it restore any missing body parts."
  ],
  "spellLists": ["artificer", "cleric", "druid", "paladin", "ranger"]
}
